/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import IEnergyManagementProps from '../../../../DashboardKPIWidgets/IEnergyManagementProps';
import { portfolioEnergyTabs } from '../../../../shared/Utils/Constants';
import PortfolioEnergyAllUtilitiesVD from '../AllUtilitiesDetails/PortfolioEnergyAllUtilitiesVD';

export const PortfolioEnergyAllVD = (props: IEnergyManagementProps) => {
  return (
    <PortfolioEnergyAllUtilitiesVD
      {...props}
      utilityType={portfolioEnergyTabs.All}
    />
  );
};
export const PortfolioEnergyElectricityVD = (props: IEnergyManagementProps) => {
  return (
    <PortfolioEnergyAllUtilitiesVD
      {...props}
      utilityType={portfolioEnergyTabs.Electric}
    />
  );
};
export const PortfolioEnergyGasVD = (props: IEnergyManagementProps) => {
  return (
    <PortfolioEnergyAllUtilitiesVD
      {...props}
      utilityType={portfolioEnergyTabs.Gas}
    />
  );
};
export const PortfolioEnergyWaterVD = (props: IEnergyManagementProps) => {
  return (
    <PortfolioEnergyAllUtilitiesVD
      {...props}
      utilityType={portfolioEnergyTabs.Water}
    />
  );
};
